import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=255b4f92&scoped=true"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&id=255b4f92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255b4f92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255b4f92')) {
      api.createRecord('255b4f92', component.options)
    } else {
      api.reload('255b4f92', component.options)
    }
    module.hot.accept("./PurchaseOrder.vue?vue&type=template&id=255b4f92&scoped=true", function () {
      api.rerender('255b4f92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/userDetails/components/PurchaseOrder.vue"
export default component.exports